import { render } from "./CredentialSetupComponent.vue?vue&type=template&id=15707592&scoped=true"
import script from "./CredentialSetupComponent.vue?vue&type=script&lang=js"
export * from "./CredentialSetupComponent.vue?vue&type=script&lang=js"

import "./CredentialSetupComponent.vue?vue&type=style&index=0&id=15707592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15707592"]])

export default __exports__